import React from 'react';
import { Link } from 'react-router-dom';
import '../../Styles/Auth/AuthFooter.css';

const AuthFooter: React.FC = () => {
  return (
    <footer className="auth-footer">
      <Link to="/pricing">Pricing</Link>
      <span className="separator">|</span>
      <a href="https://cognora.ca/terms-of-service" target="_blank" rel="noopener noreferrer">Terms of Service</a>
      <span className="separator">|</span>
      <a href="https://cognora.ca/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
    </footer>
  );
};

export default AuthFooter;
